import { render, staticRenderFns } from "./release-notes.vue?vue&type=template&id=59e064de&"
import script from "./release-notes.vue?vue&type=script&lang=tsx&"
export * from "./release-notes.vue?vue&type=script&lang=tsx&"
import style0 from "./release-notes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports